<script>
  import {
    Auth0Context,
    Auth0LoginButton,
    Auth0LogoutButton,
    login,
    logout,
    authError,
    authToken,
    idToken,
    isAuthenticated,
    isLoading,
    userInfo,
  } from '@dopry/svelte-auth0';
  import Router from 'svelte-spa-router';
  import Home from './components/Home.svelte';
  import HomePublic from './components/HomePublic.svelte';
  import CatalogCart from './components/CatalogCart.svelte';
  import Approve from './components/Approve.svelte';
  import Support from './components/Support.svelte';
  import AdminUser from './components/AdminUser.svelte';
  import AdminMarketStore from './components/AdminMarketStore.svelte';
  import AdminCatalog from './components/AdminCatalog.svelte';
  import {
    Navbar,
    NavbarBrand,
    Nav,
    NavLink,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from 'sveltestrap';
  const routes = {
    '/': Home,
    '/order': CatalogCart,
    '/approve': Approve,
    '/support': Support,
    '/adminUser': AdminUser,
    '/adminCatalog': AdminCatalog,
    '/adminMarketStore': AdminMarketStore,
    '/adminStore': AdminCatalog,
    '*': Home,
  };
</script>

<Auth0Context
  domain="ha-tcc-oo.us.auth0.com"
  client_id="Z6GmnKSexTtSqk2N01hHaC8jr9py8p9Z"
  audience="https://auth0-jwt-authorizer"
>
  <Navbar>
    <NavbarBrand href="/">
      <a href="/">
        <img src="logo.png" alt="logo" height="85%" width="50%" />
      </a>
    </NavbarBrand>
    <Nav>
      {#if $isAuthenticated}
        <NavLink href="#/">Home</NavLink>
        <NavLink href="#/order">Order</NavLink>
        {#if $userInfo['http://techsteward.com/roles']?.includes('approver')}
          <NavLink href="#/approve">Approve</NavLink>
        {/if}
        {#if $userInfo['http://techsteward.com/roles']?.includes('admin')}
          <Dropdown nav inNavbar>
            <DropdownToggle nav caret>Admin</DropdownToggle>
            <DropdownMenu right>
              <DropdownItem href="#/adminCatalog">Catalog</DropdownItem>
              <DropdownItem href="#/adminMarketStore">Market/Store</DropdownItem
              >
              <DropdownItem href="#/adminUser">User</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        {/if}
        <NavLink href="#/support">Support</NavLink>
        <Auth0LogoutButton type="button" class="btn btn-warning"
          >Logout</Auth0LogoutButton
        >
      {:else}
        <span class="navbar-text"
          >Welcome, let's get started...&nbsp;&nbsp;&nbsp;</span
        >
        <Auth0LoginButton type="button" class="btn btn-success"
          >Login</Auth0LoginButton
        >
      {/if}
    </Nav>
  </Navbar>
  <hr />
  <h5>Online Ordering System</h5>
  {#if $isAuthenticated}
    <Router {routes} />
  {:else}
    <HomePublic />
  {/if}
  <br /><br /><br />
  <div style="text-align: center">Copyright © 2011-2021 - Service Champ</div>
  <br />
</Auth0Context>

<style>
</style>
